'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messages = require('common/messages');

var _adverseEvent = require('./adverse-event.html');

var _adverseEvent2 = _interopRequireDefault(_adverseEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adverseEvent2.default,
  bindings: {
    adverseEvent: '<',
    company: '<',
    animalTypes: '<',
    sexes: '<',
    states: '<',
    statuses: '<',
    symptoms: '<',
    occurrenceLikelihoods: '<',
    injuryProbabilities: '<',
    injurySeverities: '<'
  },
  controller: function () {
    function AdverseEventComponent($mdDialog, $scope, $state, AdverseEventService, LoadingService, ToastService) {
      'ngInject';

      _classCallCheck(this, AdverseEventComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AdverseEventService: AdverseEventService,
        LoadingService: LoadingService,
        ToastService: ToastService
      });
    }

    _createClass(AdverseEventComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.adverseEvent.Products = this.adverseEvent.Products || [];
      }
    }, {
      key: 'saveChanges',
      value: function saveChanges() {
        var _this = this;

        var saveMessage = this.adverseEvent.AEId ? _messages.ADVERSE_EVENT_EDITED : _messages.ADVERSE_EVENT_ADDED;
        var promise = void 0;

        if (this.adverseEvent.AEId) {
          promise = this.AdverseEventService.update(this.adverseEvent);
        } else {
          promise = this.AdverseEventService.create(this.adverseEvent);
        }

        this.LoadingService.start();
        promise.then(function (r) {
          _this.ToastService.showSuccess(saveMessage);
          _this.adverseEvent.AEId = _this.adverseEvent.AEId || r.data.Id;

          return Promise.resolve(true);
        }).then(function () {
          return _this.$state.go('adverseEventEdit', { id: _this.adverseEvent.AEId }, { reload: true });
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        }).finally(function () {
          return _this.LoadingService.stop();
        });
      }
    }]);

    return AdverseEventComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.component.js